import React, { PureComponent } from 'react';
import cx from 'classnames';
import { scaleLinear } from 'd3-scale';
import { max, extent } from 'd3-array';
import { line } from 'd3-shape';

import { numberFormat } from '~/core/scripts/utils';
import { is400Query } from '~/core/scripts/mediaquery-helper'

import './LineChart.styl';

const isVerySmallScreen = !is400Query();

class LineChart extends PureComponent {
  static defaultProps = {
    className: '',
    width: isVerySmallScreen ? 120 : 140,
    height: isVerySmallScreen ? 35 : 40,
    data: [],
    padding: 5
  }

  render() {
    const { className, width, height, data, padding } = this.props;

    const wrapperClasses = cx('line-chart', className);
    const minmax = extent(data);
    const xScale = scaleLinear().domain([0, data.length - 1]).range([padding, width - padding - 30]);
    const yScale = scaleLinear().domain(minmax).range([height - padding, padding + 10]);
    const lastIndex = data.length - 1;
    const lastValue = data[data.length - 1];
    const firstValue = data[0];

    const path = line()
      .x((d, i) => xScale(i))
      .y(d => yScale(d));

    return (
      <div className={wrapperClasses}>
        <svg className="line-chart-svg" width={width} height={height}>
          <path className="line-chart-line" d={path(data)} />
          <circle className="line-chart-dot" cx={xScale(lastIndex)} cy={yScale(lastValue)} r={2} />
          <text className="line-chart-label" x={xScale(0)} y={yScale(firstValue) - 5}>{numberFormat(firstValue, 1)} %</text>
          <text className="line-chart-label" x={xScale(lastIndex) + 3} y={yScale(lastValue) + 3}>{numberFormat(lastValue, 1)} %</text>
        </svg>
      </div>
    );
  }
}

export default LineChart;
